import { useSelector } from 'react-redux';
import { AppFontAwesomeIcon, AppRemixIcon } from '@/layout/AppComponents';
import styled from 'styled-components';
import Scrollbars from 'react-custom-scrollbars';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import _ from 'lodash';

export default function GGCLStatesBlock(props) {
  const { obligationID } = props;
  const poLevel3 = useSelector(
    (state) => state.currentPage?.obligationLevels?.level3
  );
  return (
    <div className="oBlock-states">
      <Scrollbars style={{ height: '150px' }}>
        <div className="obBlock-state-list">
          {_.map(poLevel3?.[obligationID]?.states?.states, (s) => (
            <OverlayTrigger
              key={s.name}
              placement="top"
              overlay={<Tooltip>{`${s.name} - ${s.percent}%`}</Tooltip>}
            >
              <State
                key={s.name}
                className="d-flex align-items-center"
                $bgColor={s.bgColor}
                $iconColor={s.iconColor}
              >
                {s.iconType === 'fa' ? (
                  <AppFontAwesomeIcon icon={s.icon} className="mr-1" />
                ) : s.iconType === 'ri' ? (
                  <AppRemixIcon icon={s.icon} className="mr-1" />
                ) : (
                  <i>{s.icon}</i>
                )}

                {`${s.count} (${s.percent}%)`}
              </State>
            </OverlayTrigger>
          ))}
        </div>
      </Scrollbars>
    </div>
  );
}

const State = styled.div`
  padding: 4px 4px;
  font-size: 10px;
  i {
    cursor: default;
    height: 20px;
    width: 20px;
    padding: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px;
    background: ${(props) => props.$bgColor};
    color: ${(props) => props.$iconColor};
  }
`;
